import React, { useState, useContext, useEffect } from 'react'
import CustomInput from '../../product/components/atoms/Inputs/CustomInput'
import SecondaryButton from '@/product/components/atoms/SecondaryButton'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import Layout from '../../product/components/templates/Layout'
import { mapData } from '@/product/common/components'
import { Button, Dialog, Divider } from '@mui/material'
import DeleteIcon from '@mui/icons-material/Delete'
import { useFormik } from 'formik'
import moment from 'moment'
import * as Yup from 'yup'
import './Message.css'
import CloseIcon from '@mui/icons-material/Close'
import CustomDialog from '@/product/components/organisms/Dialog'
import AuthContext from '@/product/context/auth/authContext'
import MessageContext from '@/product/context/message/messageContext'

const Conversations = (props) => {
    const authContext = useContext(AuthContext)
    const { user, isAuthenticated } = authContext
    const messageContext = useContext(MessageContext)
    const { responseStatus: responseStatusMessage } = messageContext
    const [message, setMessage] = useState('')
    const [deleteConfirmationPopup, setDeleteConfirmationPopup] =
        useState(false)
    const [messageId, setMessageId] = useState('')
    const [uploadedFile, setUploadedFile] = useState()
    const [fileModal, setFileModal] = useState(false)
    const [initialValues, setInitialValues] = useState({
        message: '',
        attachment: '',
        archive: 0,
    })
    const validationArray = Yup.object({
        message: Yup.string().required('Required!'),
    })

    const formik = useFormik({
        initialValues: initialValues,
        validateOnBlur: false,
        enableReinitialize: true,
        validationSchema: validationArray,
        onSubmit: (values) => {
            props.handleMessageSubmit(values)
            formik.handleReset()
        },
    })

    useEffect(() => {
        scrollToBottom()
    }, [props.conversations])

    const messageEnd = React.createRef()

    const scrollToBottom = () => {
        if (messageEnd != '') {
            messageEnd.current.scrollIntoView({ behavior: 'smooth' })
        }
    }

    const fileChangeHanlder = (e) => {
        setUploadedFile(e.target.files[0])
    }

    const DataStore = {
        formik: formik,
        data: [
            {
                label: 'Write a message',
                type: 'text',
                placeholder: 'Write a message',
                class: 'col-12',
                name: 'message',
                autoComplete: 'off',
            },
            {
                type: 'misc',
                content: (
                    <input
                        accept="image/*"
                        className="uploadInput"
                        id="contained-button-file"
                        type="file"
                        onChange={fileChangeHanlder}
                    />
                ),
                class: 'col-2',
            },
        ],
    }
    const fileValidationSchema = Yup.object({
        file_path: Yup.array()
            .min(1, 'At least one file is required')
            .required('Required!'),
    })

    const fileFormik = useFormik({
        initialValues: {
            file_path: [],
        },
        validationSchema: fileValidationSchema,
        onSubmit: (values) => {
            values.image = 1
            values.message = formik?.values?.message
            props.handleMessageSubmit(values)
            fileFormik.handleReset()
            formik.handleReset()
            setFileModal(false)
        },
    })

    const fileUpload = {
        formik: fileFormik,
        data: [
            {
                type: 'uploadDropZone',
                name: 'file_path',
                icon: 'description',
                titleText: 'Upload attachments',
                class: `col-12`,
                folder: 'messages',
                multiple: true,
            },
        ],
    }
    const handleDeleteConfirm = () => {
        setDeleteConfirmationPopup(false)
    }

    const handlePopupClose = () => {
        setFileModal(false)
    }
    const resetForm = () => {
        formik.values.message = ''
        formik.values.attachment = ''
        formik.values.archive = 0
    }

    useEffect(() => {
        if (responseStatusMessage) {
            if (
                responseStatusMessage.status === 'success' &&
                responseStatusMessage.from === 'saveMessage'
            ) {
                resetForm()
            }
        }
    }, [responseStatusMessage])

    return (
        <div className="conversations">
            <div className="conversationsCnt">
                {props.conversations.actualmessages &&
                props.conversations.actualmessages.length ? (
                    props.conversations.actualmessages.map(
                        (conversation, index) => (
                            <div key={index}>
                                <div className="dateSent d-flex justify-content-between align-items-center">
                                    <Divider />
                                    <span>{conversation.date}</span>
                                    <Divider />
                                </div>
                                {conversation.datearray.map(
                                    (conversationForDate, index) => (
                                        <div key={index}>
                                            {parseInt(
                                                conversationForDate.from_id,
                                                10
                                            ) !==
                                            parseInt(user?.admin_id, 10) ? (
                                                <div className="messageRow d-flex justify-content-start">
                                                    <div className="messageReceived">
                                                        {conversationForDate.image >
                                                        0 ? (
                                                            <>
                                                                {conversationForDate.img_basename
                                                                    .toString()
                                                                    .split(',')
                                                                    .map(
                                                                        (
                                                                            ele,
                                                                            imgIndex
                                                                        ) => {
                                                                            const fileUrl = `${global.site_url}/uploads/messages/${ele}`
                                                                            const fileExt =
                                                                                ele
                                                                                    .split(
                                                                                        '.'
                                                                                    )
                                                                                    .pop()
                                                                                    .toLowerCase()
                                                                            const isImage =
                                                                                [
                                                                                    'jpg',
                                                                                    'jpeg',
                                                                                    'png',
                                                                                    'gif',
                                                                                    'bmp',
                                                                                    'webp',
                                                                                ].includes(
                                                                                    fileExt
                                                                                )

                                                                            return (
                                                                                <div
                                                                                    key={
                                                                                        imgIndex
                                                                                    }
                                                                                    className="imageConversation"
                                                                                >
                                                                                    <a
                                                                                        href={
                                                                                            fileUrl
                                                                                        }
                                                                                        target="_blank"
                                                                                        rel="noreferrer"
                                                                                    >
                                                                                        {isImage ? (
                                                                                            <img
                                                                                                src={
                                                                                                    fileUrl
                                                                                                }
                                                                                                alt={`message-image-${imgIndex}`}
                                                                                            />
                                                                                        ) : (
                                                                                            <div
                                                                                                style={{
                                                                                                    textAlign:
                                                                                                        'center',
                                                                                                    marginTop:
                                                                                                        '-15px',
                                                                                                    marginBottom:
                                                                                                        '-15px',
                                                                                                }}
                                                                                                className="pdfContainer"
                                                                                            >
                                                                                                <i
                                                                                                    className="fas fa-file-pdf fa-3x text-white"
                                                                                                    title="PDF File"
                                                                                                    style={{
                                                                                                        color: '#111111',
                                                                                                        marginBottom:
                                                                                                            '8px',
                                                                                                    }}
                                                                                                ></i>
                                                                                                {/* <div
                                                                                                    style={{
                                                                                                        marginTop:
                                                                                                            '5px',
                                                                                                        fontSize:
                                                                                                            '0.85rem',
                                                                                                        wordBreak:
                                                                                                            'break-word',
                                                                                                        color: '#ffffff',
                                                                                                    }}
                                                                                                >
                                                                                                    {
                                                                                                        ele
                                                                                                    }
                                                                                                </div> */}
                                                                                            </div>
                                                                                        )}
                                                                                    </a>
                                                                                </div>
                                                                            )
                                                                        }
                                                                    )}

                                                                {conversationForDate?.message ? (
                                                                    <p
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: conversationForDate.message,
                                                                        }}
                                                                    ></p>
                                                                ) : null}
                                                            </>
                                                        ) : (
                                                            <p
                                                                dangerouslySetInnerHTML={{
                                                                    __html: conversationForDate.message,
                                                                }}
                                                            ></p>
                                                        )}
                                                        <span className="timeStamp">
                                                            {moment(
                                                                conversationForDate.date_sent
                                                            ).format('hh:mm A')}
                                                        </span>
                                                    </div>
                                                </div>
                                            ) : (
                                                <div className="d-flex justify-content-end">
                                                    <div className="messageSent">
                                                        {conversationForDate.image >
                                                        0 ? (
                                                            <>
                                                                {conversationForDate.img_basename
                                                                    .toString()

                                                                    .split(',')
                                                                    .map(
                                                                        (
                                                                            ele,
                                                                            index
                                                                        ) => {
                                                                            return (
                                                                                <div
                                                                                    key={
                                                                                        index
                                                                                    }
                                                                                    className="imageConversation"
                                                                                >
                                                                                    <a
                                                                                        href={
                                                                                            global.site_url +
                                                                                            '/uploads/messages/' +
                                                                                            ele
                                                                                        }
                                                                                        target="_blank"
                                                                                        rel="noreferrer"
                                                                                    >
                                                                                        <img
                                                                                            src={
                                                                                                global.site_url +
                                                                                                '/uploads/messages/' +
                                                                                                ele
                                                                                            }
                                                                                        />
                                                                                    </a>
                                                                                </div>
                                                                            )
                                                                        }
                                                                    )}
                                                                {conversationForDate?.message ? (
                                                                    <p
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: conversationForDate.message,
                                                                        }}
                                                                    ></p>
                                                                ) : null}
                                                            </>
                                                        ) : (
                                                            <p
                                                                dangerouslySetInnerHTML={{
                                                                    __html: conversationForDate.message,
                                                                }}
                                                            ></p>
                                                        )}
                                                        <span className="timeStamp">
                                                            {moment(
                                                                conversationForDate.date_sent
                                                            ).format('hh:mm A')}
                                                        </span>
                                                    </div>
                                                    <Button
                                                        className="deleteMsg"
                                                        onClick={() => {
                                                            setMessageId(
                                                                conversationForDate.id
                                                            )
                                                            setDeleteConfirmationPopup(
                                                                true
                                                            )
                                                        }}
                                                    >
                                                        <span className="material-icons">
                                                            delete
                                                        </span>
                                                    </Button>
                                                </div>
                                            )}
                                        </div>
                                    )
                                )}
                            </div>
                        )
                    )
                ) : (
                    <div className="noSelection">
                        <div className="text-center">
                            <span className="material-icons">
                                question_answer
                            </span>
                            <h4>No Conversation Selected</h4>
                            <h6>Select a conversation to view messages</h6>
                        </div>
                    </div>
                )}
                <div
                    style={{ float: 'left', clear: 'both' }}
                    ref={messageEnd}
                ></div>
            </div>
            {uploadedFile ? (
                <div className="uploadedImage">
                    <a
                        className="closeImage"
                        onClick={() => {
                            setUploadedFile('')
                        }}
                    >
                        <span className="material-icons">highlight_off</span>
                    </a>

                    <img
                        src={URL.createObjectURL(uploadedFile)}
                        className="img-thumbnail rounded float-right"
                    />
                </div>
            ) : (
                ''
            )}
            <div>
                <form
                    className="messageInput"
                    onSubmit={formik.handleSubmit}
                    autoComplete="nofill"
                >
                    {/* <CustomInput
                        label="Write a message..."
                        onChange={(e) => {
                            setMessage(e.target.value)
                        }}
                        value={message}
                    /> */}
                    <div className="row">{mapData(DataStore)}</div>
                    <div className="msgActBtn d-flex justify-content-between align-items-center">
                        <Button
                            className="attachBtn"
                            onClick={() => setFileModal(true)}
                        >
                            <span className="material-icons">attach_file</span>
                        </Button>
                        <PrimaryButton label="Send" type="submit" />
                    </div>
                </form>
            </div>
            {/* <Popup
               open={deleteConfirmationPopup}
                handleClose={() => setDeleteConfirmationPopup(false)}
                modaltitle={'Confirm Delete'}
                footer={
                    <>
                        <PrimaryButton
                            label="Confirm"
                            onClick={() => {
                                props.handleMessageDelete(
                                    messageId,
                                    props.conversations.seller_id,
                                    props.conversations.project_id,
                                )
                                setDeleteConfirmationPopup(false)
                            }}
                        />
                        <SecondaryButton
                            label="Cancel"
                            onClick={() => {
                                setDeleteConfirmationPopup(false)
                            }}
                        />
                    </>
                }
            >
                {'Delete Message'}
            </Popup> */}
            <CustomDialog
                className="fileUploadModal"
                title={'Confirm Delete'}
                open={deleteConfirmationPopup}
                function={handleDeleteConfirm}
            >
                <h2 className="fpTitle">
                    Are you sure you want to delete the Message
                </h2>
                <div className="actionWrapper">
                    <PrimaryButton
                        label="Confirm"
                        onClick={() => {
                            props.handleMessageDelete(
                                messageId,
                                props.conversations.seller_id,
                                props.conversations.project_id
                            )
                            setDeleteConfirmationPopup(false)
                        }}
                    />
                    <SecondaryButton
                        label="Cancel"
                        onClick={() => {
                            setDeleteConfirmationPopup(false)
                        }}
                    />
                </div>
            </CustomDialog>
            <Dialog
                open={fileModal}
                onClose={(handlePopupClose, 'backdropClick')}
                className="fileUploadModal"
            >
                <>
                    <Button
                        className="closeIcon"
                        onClick={() => setFileModal(false)}
                    >
                        <CloseIcon />
                    </Button>
                    <h2 className="fpTitle">
                        Upload the files you want to send.
                    </h2>
                    <form
                        onSubmit={fileFormik.handleSubmit}
                        autoComplete="nofill"
                    >
                        <div className="row">{mapData(fileUpload)}</div>
                        <div className="actionButton d-flex justify-content-center align-items-center">
                            <PrimaryButton type="submit" label="Submit" />
                        </div>
                    </form>
                </>
            </Dialog>
        </div>
    )
}

export default Conversations
